import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "@fontsource/press-start-2p";
import './index.css';
import { MoralisProvider } from 'react-moralis';
import { Helmet, HelmetProvider } from 'react-helmet-async'

const APP_ID = process.env.REACT_APP_MORALIS_APPLICATION_ID;
const SERVER_URL = process.env.REACT_APP_MORALIS_SERVER_URL;

const Application = () => {
  if (!APP_ID || !SERVER_URL)
    throw new Error(
      "Missing Moralis Application ID or Server URL. Make sure to set your .env file.",
    );
  return (
    <MoralisProvider appId={APP_ID} serverUrl={SERVER_URL}>
      <App />
    </MoralisProvider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      {/* <Helmet
      title={`WAGMI Music`}
      meta={[
          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@wagmi_music' },
          { property: 'og:title', content: 'WAGMI Music' },
          { property: 'og:type', content: 'website' },
          { property: 'og:url', content: 'https://wagmi-music.web.app/' },
          { property: 'og:image', content: "https://photos.google.com/photo/AF1QipOJfvHhkeULbGn2O455kE3LWA5j65z9ki59g-mY" },
          { property: 'og:description', content: 'WAGMI Music is web3 digital agent and protect the right of artist with the power of blockchain' },
      ]}>
      </Helmet>  */}
      <Application />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
